import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { IGlob } from '../ts/Glob';
import { config } from '../ts/config';
import { WidgetBase } from '../../../_common/platform/ts/WidgetBase';
import * as reactGlobalClick from '../../../_common/platform/ts/reactGlobalClick';
import * as permissions from '../../../_common/platform/ts/permissions';
import * as Utilities from '../../../_common/platform/ts/Utilities';
import { IPopupOptions } from '../../../pdc-platform/src/ts/actions/DialogActions';

let expandedGroups = {
    [config.DEFAULT_WIDGET_TYPE_GROUP]: true
};

interface ITypeSelectDropdownOptions extends IPopupOptions {
    key: number;
    type: string;
    disabledTypes: string[];
    dialogContainer?: any;
    buttonHeight?: number;

    onSetWidgetType?(key: number, moduleName: string): void;
    onUpdate(): void;
}

class TypeSelectDropdown extends React.Component<
    {
        zIndex: number;
        options: ITypeSelectDropdownOptions;
        glob: IGlob;
        close(): void;
    },
    {
        expandedGroups: { [key: string]: any };
    }
> {
    constructor(props) {
        super(props);

        this.state = {
            expandedGroups: expandedGroups
        };
    }

    private globalClickIndex = null;

    componentDidMount() {
        this.globalClickIndex = reactGlobalClick.register(this.props.close);
    }

    componentWillUnmount() {
        reactGlobalClick.unregister(this.globalClickIndex);
        delete this.globalClickIndex;
    }

    containerClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
        //return false; Warning 'return false is deprecated'
    };

    getClickHandler = (moduleName) => {
        return (e) => {
            this.props.close();

            if (typeof this.props.options.onSetWidgetType === 'function') {
                this.props.options.onSetWidgetType(this.props.options.key, moduleName);
            }

            if (typeof this.props.options.onUpdate === 'function') {
                this.props.options.onUpdate();
            }

            e.stopPropagation();
            e.preventDefault();
            //return false; Warning 'return false is deprecated'
        };
    };

    getTypeItem = (obj) => {
        return (
            <li
                key={`type-${obj.moduleName}`}
                className={'dropdown-item type-item' + (this.props.options.type === obj.moduleName ? ' active' : '')}
                onClick={this.getClickHandler(obj.moduleName)}
            >
                <a href="#">
                    <span className={'glyphicon glyphicon-' + obj.icon}></span>
                    {obj.name}
                </a>
            </li>
        );
    };

    toggleGroup = (key) => {
        return (e) => {
            let _expandedGroups = _.clone(this.state.expandedGroups);

            if (_expandedGroups[key]) {
                delete _expandedGroups[key];
            } else {
                _expandedGroups[key] = true;
            }

            this.setState({
                expandedGroups: _expandedGroups
            });

            expandedGroups = _expandedGroups;
        };
    };

    render() {
        const { options } = this.props;
        const dialogContainer = options.dialogContainer;

        let curContainerHeight = 0;
        let curContainerOuterHeight = 0;
        let curContainerTop = 0;

        if (dialogContainer != null) {
            const curContainerOffset = $(dialogContainer).offset();

            curContainerHeight = $(dialogContainer).height();
            curContainerOuterHeight = $(dialogContainer).outerHeight();
            curContainerTop = curContainerOffset.top;
        }

        //LL: position will be "absolute" (in Popup - Dialogs.tsx)
        //      'bottom': offset.top + element.outerHeight(),
        const containerBottom = curContainerTop + curContainerOuterHeight;
        //const bottomIndent = 200;
        //  or:
        const bottomIndent = curContainerOuterHeight / 4; // OuterHeight or Height ?
        const bottomIndentCur = containerBottom - options.top;
        const upward = bottomIndentCur < bottomIndent;
        const windowHeight = $(document.body).height();
        const bottom = windowHeight - options.top;

        const style: React.CSSProperties = {
            display: 'block',
            left: options.left,
            top: options.top + (options.buttonHeight || 30),
            zIndex: this.props.zIndex
        };

        if (upward) {
            style.bottom = bottom;
            style.top = 'auto'; // or "initial"
            //style.height = "200px";  // no-no
        }

        let disabledTypes = options.disabledTypes || [];

        let types = _.filter(WidgetBase.getTypes(), (t) => {
            return !_.contains(disabledTypes, t.moduleName);
        });

        let groups = _.groupBy(types, 'group');

        if (!permissions.createAdminWidgets()) {
            delete groups['Administrative'];
        }

        //LL: 19.03.21
        style.overflowY = 'auto';
        style.maxHeight = '200px';

        if (!upward) {
            let H = curContainerHeight - ((style.top as number) - curContainerTop);

            if (H > 0) {
                style.maxHeight = H + 'px';
            }
        } else {
            //LL: style.top is not set in this case
            let H = options.top - curContainerTop;

            if (H > 0) {
                style.maxHeight = H + 'px';
            }
        }

        return (
            <ul className="type-select-dropdown dropdown-menu" style={style}>
                {_.reduce(
                    _.keys(groups).sort(),
                    (res, key: any) => {
                        const arr = Utilities.sortByName(groups[key]);

                        let icon: React.JSX.Element;

                        if (this.state.expandedGroups[key]) {
                            icon = <span className="fa toggle fa-caret-down"></span>;
                        } else {
                            icon = <span className="fa toggle fa-caret-right"></span>;
                        }

                        res.push(
                            <li
                                className="dropdown-header dropdown-item"
                                key={`header-${key}`}
                                onClick={this.toggleGroup(key)}
                            >
                                {icon}
                                {key}
                            </li>
                        );

                        if (this.state.expandedGroups[key]) {
                            res = res.concat(
                                _.map(arr, (obj) => {
                                    return this.getTypeItem(obj);
                                })
                            );
                        }

                        return res;
                    },
                    []
                )}
            </ul>
        );
    }
}

export function WidgetTypeSelect(props: {
    id: number;
    cid?: number;
    type: string;
    disabledTypes?: string[];
    glob: IGlob;

    onUpdate?(): void;
    onSetWidgetType?(key: number, moduleName: string): void;
    getDialogContainer?();
}) {
    const [showDropdown, setShowDropdown] = React.useState<boolean>(false);
    const buttonRef = React.useRef<HTMLButtonElement>(null);

    const handleOnDropdownClick = (e) => {
        let dialogContainer;

        if (typeof props.getDialogContainer === 'function') {
            dialogContainer = props.getDialogContainer();
        }

        const offset = $(buttonRef.current).offset();

        props.glob.DialogActions.createPopup<ITypeSelectDropdownOptions>('custom', {
            top: offset.top,
            left: offset.left,
            type: props.type,
            key: props.id || props.cid,
            disabledTypes: props.disabledTypes,
            dialogContainer: dialogContainer,
            buttonHeight: buttonRef.current.offsetHeight,

            onUpdate: props.onUpdate,
            onSetWidgetType: props.onSetWidgetType,

            component: TypeSelectDropdown
        });

        setShowDropdown(!showDropdown);
    };

    const type = WidgetBase.getConstructorByName(props.type);

    let buttonContent: React.JSX.Element[];

    if (type == null) {
        buttonContent = [<strong key="strong">{'Select widget type'}</strong>];
    } else {
        buttonContent = [
            <span key={'span-icon'} className={'glyphicon glyphicon-' + type.icon}></span>,
            <span key={'span-name'}>{type._name}</span>
        ];
    }

    return (
        <div className="widget-type-select">
            <span className="widget-type-title">{'Widget type:'}</span>

            <button ref={buttonRef} type="button" className="btn btn-secondary" onClick={handleOnDropdownClick}>
                {buttonContent}

                <span className="caret"></span>
            </button>
        </div>
    );
}
